// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"39697797","453":"20359781","796":"956b99fc"}[chunkId] + ".chunk.js";
};